import React from 'react';
import { Route, Routes } from 'react-router-dom';
import JobsAnalytics from '../analytics/JobsAnalytics';
import QuotesAnalytics from '../analytics/QuotesAnalytics';
import InvoicesAnalytics from '../analytics/InvoicesAnalytics';
import FinancialAnalytics from '../analytics/FinancialAnalytics';
import EngineersAnalytics from '../analytics/EngineersAnalytics';
import PPMAnalytics from '../analytics/PPMAnalytics';
import CustomersAnalytics from '../analytics/CustomersAnalytics';
import ScheduleAnalytics from '../analytics/ScheduleAnalytics';
import FleetAnalytics from '../analytics/FleetAnalytics';

const ReportRoutes = () => {
  return (
    <Routes>
      <Route path="jobs" element={<JobsAnalytics />} />
      <Route path="quotes" element={<QuotesAnalytics />} />
      <Route path="invoices" element={<InvoicesAnalytics />} />
      <Route path="financial" element={<FinancialAnalytics />} />
      <Route path="engineers" element={<EngineersAnalytics />} />
      <Route path="ppm" element={<PPMAnalytics />} />
      <Route path="customers" element={<CustomersAnalytics />} />
      <Route path="schedule" element={<ScheduleAnalytics />} />
      <Route path="fleet" element={<FleetAnalytics />} />
    </Routes>
  );
};

export default ReportRoutes;
